// extracted by mini-css-extract-plugin
export default {"root":"FloatBtn_root__KaiRX","main":"FloatBtn_main__wd97-","handle":"FloatBtn_handle__tRd5l","foldImg":"FloatBtn_foldImg__d0cBt"};